import React, { FC } from "react";
import { GroupRule } from "../../../../../models";

type Props = {
  groupRules: GroupRule[];
  setGroupRules: (groupRules: GroupRule[]) => void;
};

const GroupRulesInput: FC<Props> = ({ groupRules, setGroupRules }) => {

  const moveGroupRule = (currentIndex: number, targetIndex: number): void => {
    if (targetIndex < 0 || targetIndex >= groupRules.length) {
      return;
    }

    const reorderedRules = [...groupRules];
    const [movedRule] = reorderedRules.splice(currentIndex, 1);
    reorderedRules.splice(targetIndex, 0, movedRule);
    setGroupRules(reorderedRules);
  };

  return (
    <div className="form-group">
      <label>Group Rules Order</label>
      <ul className="list-group">
        {groupRules.map((rule, index) => (
          <li key={rule.groupRuleId} className="list-group-item w-100">
            <div className="row w-100">
            <span className="col-8">{index + 1}. {rule.name}</span>
            <div className="col-2 d-flex justify-content-end">
              {index > 0 &&
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary mr-2"
                  onClick={(): void => moveGroupRule(index, index - 1)}
                >
                  Up
                </button>
              }
              </div>
              <div className="col-2 d-flex justify-content-start">
              {index < groupRules.length - 1 &&
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={(): void => moveGroupRule(index, index + 1)}
                >
                  Down
                </button>
              }
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GroupRulesInput;